import ga from '@ott/google-analytics';

import { MenuItem } from './Footer';

export const WHATSAPP_PHONE = '+7 926 684 1926';
export const RU_LOCALE = 'ru';

export const SKYPE_EN_ACCOUNT = 'skype:live:skypebuttonusa';
export const SKYPE_RU_ACCOUNT = 'skype:services.ott';

export const SKYPE_ACCOUNTS_BY_LANG = {
  ru: SKYPE_RU_ACCOUNT,
  'ru-kz': SKYPE_RU_ACCOUNT,
  'ru-by': SKYPE_RU_ACCOUNT,
  'ru-ua': SKYPE_RU_ACCOUNT,
  'uk-ua': SKYPE_RU_ACCOUNT,
  'en-gb': SKYPE_EN_ACCOUNT,
  'en-us': SKYPE_EN_ACCOUNT,
  'en-ie': SKYPE_EN_ACCOUNT,
  es: 'skype:live:.cid.314dacb78bd3df20',
  pl: 'skype:live:.cid.9502c804baed1ed7',
  de: 'skype:live:.cid.246655d083b4662c',
  tr: 'skype:live:.cid.a3b030217cec3f1e',
};

export const MENU_ITEM_ACTIONS = {
  paylater: {
    onClick: () => {
      ga('send', 'event', 'instalments', 'click');
    },
  },
};

export const PARTNERS_MENU_ITEMS: {
  clients: MenuItem[];
  company: MenuItem[];
} = {
  clients: ['hc', 'b2b', 'extranet'],
  company: ['about', 'jobs', 'privacy', 'reviews'],
};

export const defaultAppLinks = {
  android:
    'http://adj.otthyper.com/adjust/click/?network=OTT_Website&campaign=footer&install_callback=',
  ios: 'http://adj.otthyper.com/adjust/click/?network=OTT_Website&campaign=footer&install_callback=',
  huawei:
    'https://appgallery.cloud.huawei.com/ag/n/app/C103308519?channelId=Website&id=5b4f8c4b34f44a3e9841688b730a99c9&s=4752CFF79DF3BAE0F7A7372E6AC3F9BAEF20DD6CF61B1E60AB603FE54D752CB3&detailType=0&v=',
};
